import Button from '@/components/elements/Button';
import { useNetwork } from '@/presentation/context/network';
import Icon, { Icons } from '@/presentation/components/elements/Icon';
import Link from 'next/link';
import { useModalContext } from '@/presentation/context/modal';

const Success = () => {
  const { slug } = useNetwork();
  const { closeModal } = useModalContext();

  return (
    <div className="space-y-4">
      <div className="p-6 bg-gray-50 max-w-lg mx-auto">
        <h2 className="text-lg text-center mb-2 font-bold">{'Success'}</h2>
        <div className="p-4 flex justify-center items-center">
          <Icon name={Icons.CHECK} size={48} className="text-green-500" />
        </div>
        <p className="text-center mb-8">
          {'Your position has been increased.'}
        </p>
        <Link
          href={`/${slug}/profile/positions`}
          passHref={true}
          legacyBehavior={true}
          onClick={() => {
            closeModal();
          }}
        >
          <Button>{'View positions'}</Button>
        </Link>
      </div>
    </div>
  );
};

export default Success;
